export const layout = {
	state: {
    layout: 'main-layout',  
	},
	mutations: {
    setLayout (state, payload) {
      state.layout = payload
    },
	},
	actions: {
    
	},
	getters: {
    layout (state) {
      return state.layout
    },
	}
}




// WEBPACK FOOTER //
// ./src/store/modules/layout/index.js